import { ValidatorResult } from './DetailViewValidationCard';

export function handleRunValidator<T>(
  section: string,
  data: T | null,
  validator: (d: T | null) => ValidatorResult,
  currState: Record<string, ValidatorResult>,
  stateSetter: React.Dispatch<React.SetStateAction<Record<string, ValidatorResult>>>
): ValidatorResult {
  const result = validator(data);

  if (
    currState[section]?.isValid !== result.isValid ||
    (!result.invalidFields.every((field) => currState[section]?.invalidFields.includes(field)) &&
      !currState[section]?.invalidFields.every((field) => result.invalidFields.includes(field)))
  ) {
    stateSetter((prev) => ({
      ...prev,
      [section]: result
    }));
  }
  return result;
}

export const formatValidationMessages = (validationsBySection: Record<string, ValidatorResult>) => {
  return Object.values(validationsBySection).reduce((acc: string[], curr: ValidatorResult): string[] => {
    if (!curr.isValid) {
      const fieldMessages = curr.messages.map((msg) => msg.message);
      acc.push(...fieldMessages);
    }
    return acc;
  }, []);
};
